export default "__VITE_ASSET__CEj4TpIU__"